<template>
  <b-modal
    id="modal-video"
    :title="`${this.$t('notification.object.notificationVideo')} - ${getAlertDesc(
      dataVideo?.alert
    )}`"
    size="xl"
    centered
    ref="modal-video"
    :modal-class="`mc-modal-video ${
      !isFullScreen ? 'mc-modal-video--liveview' : 'mc-modal-video--liveview-full'
    }`"
  >
    <div class="mc-modal-video__Wrapper">
      <div class="mc-modal-video__top">
        <b-row>
          <b-col md="2">
            <div class="mc-modal-video__top-item">
              <span class="d-block text-muted">{{ $t('global.object.licensePlate') }}</span>
              <div>
                <strong>{{ dataVideo.vehicle ? dataVideo.vehicle.licensePlate : '-' }}</strong>
                <b-badge class="bg-success" :title="$t('liveView.filter.moving')">{{
                  $t('liveView.filter.moving')
                }}</b-badge>
              </div>
            </div>
          </b-col>
          <b-col md="2">
            <div class="mc-modal-video__top-item">
              <span class="d-block text-muted">{{ $t('global.object.fleetCategory') }}</span>
              <strong>{{
                dataVideo.vehicle
                  ? dataVideo.vehicle.vehicleType
                    ? dataVideo.vehicle.vehicleType.category
                    : '-'
                  : '-'
              }}</strong>
            </div>
          </b-col>
          <b-col md="2">
            <div class="mc-modal-video__top-item">
              <span class="d-block text-muted">{{ $t('global.object.driver') }}</span>
              <strong>{{ dataVideo.driver ? dataVideo.driver.fullname : '-' }}</strong>
            </div>
          </b-col>
          <b-col md="2">
            <div class="mc-modal-video__top-item">
              <span class="d-block text-muted">{{ $t('global.object.phoneNumber') }} GPS</span>
              <strong>{{
                dataVideo.vehicle
                  ? dataVideo.vehicle.device
                    ? dataVideo.vehicle.device.phoneNo
                    : '-'
                  : '-'
              }}</strong>
            </div>
          </b-col>
          <b-col md="2">
            <div class="mc-modal-video__top-item">
              <span class="d-block text-muted">IMEI</span>
              <strong>{{ dataVideo.vehicle ? dataVideo.vehicle.imei ?? '-' : '-' }}</strong>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="mc-modal-video__content">
        <div
          class="mc-trackvideo-list__item-video-content-wrapper mc-trackvideo-list__item-video-content-open"
        >
          <div class="mc-trackvideo-list__item-video-content-open-source">
            <video-player
              ref="videoInPlayerNotif"
              class="vjs-custom-skin"
              :options="playerInOptions"
              @ready="onInPlayerReady($event)"
              @error="onInPlayerError($event)"
              @waiting="onInPlayerWaiting($event)"
              @loadeddata="onInPlayerLoadedData($event)"
              @ended="onInPlayerEnded($event)"
            />
          </div>
          <div class="d-flex justify-content-between mc-trackvideo-list__item-video-content-action">
            <div>
              <span>
                <i
                  class="mc-fa icon-outline_play-circle"
                  v-if="!isPlay"
                  @click="playInVideo(true)"
                ></i>
                <i
                  class="mc-fa icon-outline_pause-circle"
                  v-if="isPlay"
                  @click="playInVideo(false)"
                ></i>
              </span>
            </div>
            <div>
              <span>
                <i
                  class="mc-fa icon-outline_volume-up"
                  v-if="!isMuted"
                  @click="muteInVideo(true)"
                ></i>
                <i
                  class="mc-fa icon-outline_volume-off"
                  v-if="isMuted"
                  @click="muteInVideo(false)"
                ></i>
              </span>
              <i v-if="!isFullScreen" class="mc-fa icon-outline_expand" @click="fullScreen"></i>
              <i v-else class="mc-fa icon-outline_collapse" @click="closeFullscreen"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template #modal-footer="{ cancel }">
      <b-row class="mc-modal__filter-footer">
        <b-col sm="12" md="6" class="mc-modal__filter-footer-fav" />

        <b-col sm="12" md="6" class="mc-modal__filter-footer-btn">
          <b-button variant="outline-primary" @click="cancel()" class="me-3">
            {{ $t('global.action.close') }}
          </b-button>
          <a :href="dataVideo.formattedAlertData" download class="btn btn-primary">
            <i class="mc-fa icon-outline_download"></i> {{ $t('global.action.download') }}
          </a>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>
<script>
import VideoPlayer from '@/components/Video/VideoPlayer.vue'
import { Helper } from '@/mixin/helper'

export default {
  components: {
    VideoPlayer,
  },
  mixins: [Helper],
  props: {
    dataVideo: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      playerInOptions: {
        autoplay: true,
        controls: false,
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
        },
        sources: [
          {
            src: '',
            type: 'video/mp4',
          },
        ],

        // poster: 'https://surmon-china.github.io/vue-quill-editor/static/images/surmon-5.jpg'
      },
      refsName: `videoInPlayerNotif`,
      isPlay: true,
      isMuted: false,
      isFullScreen: false,
    }
  },

  mounted() {
    this.playerInOptions.sources[0].src = this.dataVideo.formattedAlertData
  },
  methods: {
    hideModalVideo() {
      this.$refs['modal-video'].hide()
    },
    onInPlayerReady() {
      this.$refs[this.refsName].player.play()
    },
    onInPlayerError(e) {
      console.log(e)
    },
    onInPlayerWaiting() {
      setTimeout(() => {
        this.$refs[this.refsName].player.pause()
      }, 20 * 1000)
    },
    onInPlayerLoadedData(e) {
      console.log(e)
    },
    onInPlayerEnded() {
      this.$refs[this.refsName].player.pause()
      this.isPlay = !this.isPlay
    },
    playInVideo(isPlay) {
      this.isPlay = !this.isPlay
      if (!isPlay) {
        this.$refs[this.refsName].player.pause()
        return
      }

      this.$refs[this.refsName].player.play()
    },
    muteInVideo(isMuted) {
      this.isMuted = !this.isMuted
      this.$refs[this.refsName].player.muted(isMuted)
    },
    fullScreen() {
      this.isFullScreen = true
      let elem = document.documentElement

      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen()
      }
    },
    closeFullscreen() {
      this.isFullScreen = false
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.webkitExitFullscreen) {
        /* Safari */
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        /* IE11 */
        document.msExitFullscreen()
      }
    },
  },
}
</script>
